/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
//import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
//import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
//import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
//import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
//import Image from '@ckeditor/ckeditor5-image/src/image';
//import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
//import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
//import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
//import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
//import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';

export default class ClassicEditor extends ClassicEditorBase {}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
    Essentials,
    //UploadAdapter,
    //Autoformat,
    Bold,
    Italic,
    Underline,
    Superscript,
    Subscript,
    BlockQuote,
    //CKFinder,
    //EasyImage,
    Heading,
    //Image,
    //ImageCaption,
    //ImageStyle,
    //ImageToolbar,
    //ImageUpload,
    Link,
    List,
    //MediaEmbed,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    Strikethrough
];

// Editor configuration.
ClassicEditor.defaultConfig = {
    toolbar: {
        items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'link',
            'bulletedList',
            'numberedList',
            //'imageUpload',
            'blockQuote',
            'insertTable',
            'superscript',
            'subscript',
            'strikethrough'
            //'mediaEmbed',
            //'undo',
            //'redo'
        ]
    },
    // image: {
    //     toolbar: [
    //         'imageStyle:full',
    //         'imageStyle:side',
    //         '|',
    //         'imageTextAlternative'
    //     ]
    // },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    heading: {
        options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h3', title: 'Nadpis', class: 'ck-heading_heading3' },
        ]
    },
    link: {
        decorators: {
            sponsoredRel: {
                mode: 'manual',
                label: 'Placený odkaz (rel=sponsored)',
                attributes: {
                    rel: 'sponsored'
                }
            },
            nofollowRel: {
                mode: 'manual',
                label: 'Nofollow (rel=nofollow)',
                attributes: {
                    rel: 'nofollow'
                }
            }
        }
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'cs'
};
